var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabricksSelectedWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1288_13407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.272461C18.6274 0.272461 24 5.64504 24 12.2725C24 18.8999 18.6274 24.2725 12 24.2725C5.37258 24.2725 0 18.8999 0 12.2725C0 5.64504 5.37258 0.272461 12 0.272461ZM2.00293 7.97461V8.51465L12.0029 13.1777L20.9795 9.01562V10.71L12.0029 14.9121L2.51465 10.4424L2.00391 10.6738L2.00293 13.9102L12.0029 18.5752L20.9795 14.4121V16.0693L12.0029 20.2686L2.51465 15.7988L2.00391 16.0303V16.6074L12.0029 21.2725L22.0029 16.6094V13.3711L21.5371 13.1396L12.0029 17.6113L3.07324 13.3711V11.7139L12.0029 15.876L22.0029 11.2129V8.0127L21.5371 7.78125L12.0029 12.2529L3.53906 8.2832L12.0029 4.31348L19.0254 7.58984L19.6299 7.28125V6.85645L12.0029 3.27246L2.00293 7.97461Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1288_13407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabricksSelectedWhite);
export default __webpack_public_path__ + "static/media/Databricks_Selected_White.23e230738273fd2796d41abbae8918bd.svg";
export { ForwardRef as ReactComponent };